import "./index_page.css";
import WebsiteName from "../common/WebsiteName/WebsiteName";
import Navbar from "../common/Navbar/NavBar";
import MainSec0 from "./Main/main_sec_0";
import MainSec1 from "./Main/Main_Sec_1";
import ImageDeco from "../common/Image_Deco/Image_Deco";
import MainCoursesection from "./Main_Course_section/Main_Course_section";
import Footer from "../common/Footer/Footer";
export default function index_page() {
  return (
    <>
      <section className="bgHomeImage">
        <WebsiteName />
        <Navbar />
        <MainSec0 />
        <MainSec1 />
        <ImageDeco />
        <MainCoursesection />
        <Footer />
      </section>
    </>
  );
}
